import { Await, LinkProps } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { Action, Crumb } from "modules/shared/lib/breadcrumbs"
import { Suspense } from "react"
import { useTranslation } from "react-i18next"

export function CrumbActions({ crumb }: { crumb?: Crumb }) {
  const { t } = useTranslation()

  if (!crumb) return null

  const actions = crumb.getActions(t)

  if (!actions) return null

  function renderActions(isFallback: boolean, actions: Action[]) {
    return actions.map((action) => {
      if ("component" in action) {
        return action.component
      }

      const { id, title, icon: Icon, variant, search, params, ...props } = action

      const to = "to" in props ? (props.to as LinkProps["to"]) : undefined
      const onClick = "onClick" in props ? props.onClick : undefined

      return (
        <ButtonLink
          key={id}
          to={to}
          onClick={onClick}
          params={params}
          search={(prev: unknown) => search || (to?.includes(location.pathname) && prev) || {}}
          variant={variant}
          size="default"
          title={title}
          className="flex items-center gap-2"
        >
          <span className="relative">
            <Icon className="w-4 h-4" strokeWidth={2} />
          </span>
          {title && <span className="hidden lg:flex">{title}</span>}
        </ButtonLink>
      )
    })
  }

  if (actions.kind === "defer") {
    return (
      <Suspense fallback={null}>
        <Await promise={actions.value}>
          {(data) => {
            return renderActions(false, data)
          }}
        </Await>
      </Suspense>
    )
  }

  return renderActions(false, actions.value)
}
